export const AUTHORIZE_LINK_VALIDATE_REQUEST =
  "AUTHORIZE_LINK_VALIDATE_REQUEST";
export const AUTHORIZE_LINK_VALIDATE_SUCCESSFUL =
  "AUTHORIZE_LINK_VALIDATE_SUCCESSFUL";
export const AUTHORIZE_LINK_VALIDATE_ERROR = "AUTHORIZE_LINK_VALIDATE_ERROR";

export const AUTHORIZE_PASSCODE_VALIDATE_REQUEST =
  "AUTHORIZE_PASSCODE_VALIDATE_REQUEST";
export const AUTHORIZE_PASSCODE_VALIDATE_SUCCESSFUL =
  "AUTHORIZE_PASSCODE_VALIDATE_SUCCESSFUL";
export const AUTHORIZE_PASSCODE_VALIDATE_ERROR =
  "AUTHORIZE_PASSCODE_VALIDATE_ERROR";

export const AUTHORIZE_PAANS_CHECK_REQUEST = "AUTHORIZE_PAANS_CHECK_REQUEST";
export const AUTHORIZE_PAANS_CHECK_SUCCESSFUL =
  "AUTHORIZE_PAANS_CHECK_SUCCESSFUL";
export const AUTHORIZE_PAANS_CHECK_ERROR = "AUTHORIZE_PAANS_CHECK_ERROR";

export const AUTHORIZE_LINK_ACTION_DATA_REQUEST =
  "AUTHORIZE_LINK_ACTION_DATA_REQUEST";
export const AUTHORIZE_LINK_ACTION_DATA_SUCCESSFUL =
  "AUTHORIZE_LINK_ACTION_DATA_SUCCESSFUL";
export const AUTHORIZE_LINK_ACTION_DATA_ERROR =
  "AUTHORIZE_LINK_ACTION_DATA_ERROR";

export const AUTHORIZE_LINK_ACTION_DETAIL_REQUEST =
  "AUTHORIZE_LINK_ACTION_DETAIL_REQUEST";
export const AUTHORIZE_LINK_ACTION_DETAIL_SUCCESSFUL =
  "AUTHORIZE_LINK_ACTION_DETAIL_SUCCESSFUL";
export const AUTHORIZE_LINK_ACTION_DETAIL_ERROR =
  "AUTHORIZE_LINK_ACTION_DETAIL_ERROR";

export const AUTHORIZE_LINK_ENUM_ACTION_TYPE_REQUEST =
  "AUTHORIZE_LINK_ENUM_ACTION_TYPE_REQUEST";
export const AUTHORIZE_LINK_ENUM_ACTION_TYPE_SUCCESSFUL =
  "AUTHORIZE_LINK_ENUM_ACTION_TYPE_SUCCESSFUL";
export const AUTHORIZE_LINK_ENUM_ACTION_TYPE_ERROR =
  "AUTHORIZE_LINK_ENUM_ACTION_TYPE_ERROR";

export const AUTHORIZE_LINK_ENUM_ACTION_VALIDATION_REQUEST =
  "AUTHORIZE_LINK_ENUM_ACTION_VALIDATION_REQUEST";
export const AUTHORIZE_LINK_ENUM_ACTION_VALIDATION_SUCCESSFUL =
  "AUTHORIZE_LINK_ENUM_ACTION_VALIDATION_SUCCESSFUL";
export const AUTHORIZE_LINK_ENUM_ACTION_VALIDATION_ERROR =
  "AUTHORIZE_LINK_ENUM_ACTION_VALIDATION_ERROR";

export const AUTHORIZE_LINK_UPDATE_STATUS = "AUTHORIZE_LINK_UPDATE_STATUS";

export const GO_LINK_REQUEST = "GO_LINK_REQUEST";
export const GO_LINK_SUCCESSFUL = "GO_LINK_SUCCESSFUL";
export const GO_LINK_ERROR = "GO_LINK_ERROR";

export const AUTHORIZE_LINK_EXPIRE_ON_LINK_REQUEST =
  "AUTHORIZE_LINK_EXPIRE_ON_LINK_REQUEST";

export const AUTHORIZE_PASSCODE_ACTION_DATA_REQUEST =
  "AUTHORIZE_PASSCODE_ACTION_DATA_REQUEST";
export const AUTHORIZE_PASSCODE_ACTION_DATA_SUCCESSFUL =
  "AUTHORIZE_PASSCODE_ACTION_DATA_SUCCESSFUL";
export const AUTHORIZE_PASSCODE_ACTION_DATA_ERROR =
  "AUTHORIZE_PASSCODE_ACTION_DATA_ERROR";

export const AUTHORIZE_GET_CONFIRMATION_STATUS_REQUEST =
  "AUTHORIZE_GET_CONFIRMATION_STATUS_REQUEST";

export const AUTHORIZE_GET_CONFIRMATION_STATUS_SUCCESSFUL =
  "AUTHORIZE_GET_CONFIRMATION_STATUS_SUCCESSFUL";

export const AUTHORIZE_GET_CONFIRMATION_STATUS_ERROR =
  "AUTHORIZE_GET_CONFIRMATION_STATUS_ERROR";

export const AUTHORIZE_GET_DOWNSTREAM_REQUEST_ACTIVE =
  "AUTHORIZE_GET_DOWNSTREAM_REQUEST_ACTIVE";
export const AUTHORIZE_GET_DOWNSTREAM_REQUEST_ACTIVE_SUCCESSFUL =
  "AUTHORIZE_GET_DOWNSTREAM_REQUEST_ACTIVE_SUCCESSFUL";
export const AUTHORIZE_GET_DOWNSTREAM_REQUEST_ACTIVE_ERROR =
  "AUTHORIZE_GET_DOWNSTREAM_REQUEST_ACTIVE_ERROR";

export const GET_SETTINGS = "GET_SETTINGS";
export const GET_SETTINGS_SUCCESS = "GET_SETTINGS_SUCCESS";
export const GET_SETTINGS_ERROR = "GET_SETTINGS_ERROR";

export const AUTHORIZE_LINK_GENERATE_VALIDATOR_REQUEST = "AUTHORIZE_LINK_GENERATE_VALIDATOR_REQUEST";

export const AUTHORIZE_LINK_LINKS_EXPIRE_SUCCESSFUL = "AUTHORIZE_LINK_LINKS_EXPIRE_SUCCESSFUL";